import { UserModel, type IUserPermissions, type NetworkUser, type UserUpdatePayloadModel } from '@/models/user';
import { signedApiClient } from '@/services/apiClient';

class UserService {

  private userEndpoint: string = '';
  initService(userEndpoint: string) {
    this.userEndpoint = userEndpoint;
  }
  async getUserDetails(id: string) {
    const uri = `${this.userEndpoint}/${id}/details`;
    const apiClient = signedApiClient('GET', uri);
    const userResponse = await apiClient.get(uri);
    const user: NetworkUser = userResponse.data;
    return UserModel.mapFromBackend(user, id, []);
  }

  async patchUserPermissions(id: string, permissions: IUserPermissions) {
    const uri = `${this.userEndpoint}/${id}/permissions`;
    const apiClient = signedApiClient('PATCH', uri);
    return await apiClient.patch(uri, permissions);
  }

  async patchUserDetails(payload: UserUpdatePayloadModel, userHex: string) {
    const uri = `${this.userEndpoint}/${userHex}/details`;
    const apiClient = signedApiClient('PATCH', uri);
    return await apiClient.patch(uri, payload);
  }

  async registerFCMToken(token: string, userHex: string) {
    const uri = `${this.userEndpoint}/${userHex}/device`;
    const apiClient = signedApiClient('POST', uri);
    const res = await apiClient.post(uri, { token, platform: 'fcm_web' });
    return res.status === 200;
  }
}

export default new UserService();
